import { ReactNode, ReactElement } from "react";
import { Sheets } from "@ingka/modal";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/modal/dist/style.css";
import "@ingka/focus/dist/style.css";

interface LabelIdSheetsProps {
  labelledById: string;
}

interface LabelSheetsProps {
  ariaLabel: string;
}

interface BaseSheetsProps {
  alignment?: "left" | "right";
  preserveAlignment?: boolean;
  size?: "small" | "medium" | "large";
  fullSize?: boolean;
  header: ReactElement | null;
  footer: ReactElement | null;
  children: ReactNode | ReactNode[];
  className?: string;
}

export type SheetsProps = BaseSheetsProps &
  (LabelSheetsProps | LabelIdSheetsProps);

export const FixaSheets = (props: SheetsProps) => {
  return <Sheets {...props} />;
};
